<div *ngIf="dSS.dienststelle && dSS.modusErweitert" class="ride-group">
  <ion-row>
    <ion-col>
      <h3>Beschäftigungsmerkmale</h3>
    </ion-col>
  </ion-row>
</div>
<ion-row>
  <ion-col size="12">
    <ion-item lines="inset">
      <ion-select
        label="Art der Beschäftigung"
        labelPlacement="floating"
        interface="popover"
        [(ngModel)]="dSS.bArt"
        (ionChange)="update($event, true)"
        [disabled]="!!dSS.dienststelle?.disabledBArt"
      >
        <ion-select-option
          *ngFor="let option of bArtList"
          [value]="option.value"
        >
          {{ option.display }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col class="position-relative">
    <span
      *ngIf="!dSS.bruttogehaltTouched && !!dSS.bruttogehalt"
      class="rd-example-badge"
      >Beispielwert</span
    >
    <ion-item
      lines="inset"
      id="rd-field-bruttogehalt"
      class="required-field"
      [class.is-empty]="!dSS.bruttogehalt"
      [class.is-untouched]="!dSS.bruttogehaltTouched && !!dSS.bruttogehalt"
      [class.is-error]="dSS.showRequiredErrors && (!dSS.bruttogehalt || !dSS.bruttogehaltTouched)"
    >
      <ion-label position="stacked" *ngIf="dSS.dsCode.toLowerCase() === 'aok-1223'">
        <div class="info-label">
          <span
            >Bruttomonatsentgelt<span
              *ngIf="!dSS.bruttogehalt"
              class="rd-required-mark"
              aria-hidden="true"
            ></span
          ></span>
          <ion-icon
            class="info-icon"
            name="information-circle-outline"
            (click)="dSS.toggleInfo('Bruttogehalt')"
          ></ion-icon>
        </div>
      </ion-label>
      <ion-input
        [label]="dSS.dsCode.toLowerCase() === 'aok-1223' ? '' : 'Bruttomonatsentgelt'"
        labelPlacement="floating"
        type="number"
        pattern="\d+(\.\d{1,2})?"
        [min]="1"
        [(ngModel)]="dSS.bruttogehalt"
        (ionChange)="update($event)"
        (ionFocus)="dSS.bruttogehaltTouched = true"
        (ionInput)="dSS.bruttogehaltTouched = true"
        placeholder="Angabe erforderlich!"
        [required]="true"
      >
        <ion-icon
          *ngIf="dSS.bruttogehalt"
          name="logo-euro"
          class="eur_logo__position"
        ></ion-icon>
      </ion-input>
    </ion-item>
    <div *ngIf="dSS.currInfo === 'Bruttogehalt'" class="info-box">
      <p class="info-text">
        ist gleich Steuerbrutto aus regelm. Gehaltsabrechnung Arbeitgeberin.
      </p>
    </div>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-list>
      <ion-item lines="inset">
        <ion-select
          label="Steuerklasse"
          labelPlacement="floating"
          interface="popover"
          [(ngModel)]="dSS.stKlasse"
          (ionChange)="update($event)"
        >
          <ion-select-option *ngFor="let option of stKList" [value]="option">
            {{ option }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </ion-col>
</ion-row>
<ng-container *ngIf="dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Kinderfreibetrag"
            labelPlacement="floating"
            interface="popover"
            [(ngModel)]="dSS.kinderValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of kinderList"
              [value]="option"
            >
              {{ option == 6 ? "6+" : option }}</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Kirchensteuer"
            labelPlacement="floating"
            interface="popover"
            [(ngModel)]="dSS.kircheValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Bundesland"
            labelPlacement="floating"
            interface="popover"
            [(ngModel)]="dSS.dienststelle.bundesland"
            (ionChange)="update($event)"
            [disabled]="dSS.dienststelle.disabledBundesland"
          >
            <ion-select-option
              *ngFor="let option of bundesl"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Rentenversicherungspflicht"
            labelPlacement="floating"
            interface="popover"
            [(ngModel)]="this.dSS.rvValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Krankenversicherung"
            labelPlacement="floating"
            interface="popover"
            [(ngModel)]="dSS.kvValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of kvList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ng-container *ngIf="dSS.kvValue === 'gkv'">
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="Regelsatz Krankenversicherung %"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.rsValue"
            (ionChange)="update($event)"
            placeholder="Angabe erforderlich!"
            [required]="true"
          >
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="position-relative">
        <ion-item lines="inset">
          <ion-label position="stacked" *ngIf="dSS.isVivantes()">
            <div class="info-label">
              <span>Zusatzbeitrag Krankenversicherung %</span>
              <ion-icon
                class="info-icon"
                name="information-circle-outline"
                (click)="dSS.toggleInfo('zKVInfoViv')"
              ></ion-icon>
            </div>
          </ion-label>
          <ion-input
            [label]="dSS.isVivantes() ? '' : 'Zusatzbeitrag Krankenversicherung %'"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.zusatzValue"
            (ionChange)="update($event)"
            placeholder="Angabe erforderlich!"
            [required]="true"
          >
          </ion-input>
        </ion-item>
        <div *ngIf="dSS.currInfo === 'zKVInfoViv'" class="info-box">
          <p class="info-text">
            Der von den gesetzlichen Krankenkassen abhängige Zusatzbeitrag, den
            das Gesundheitsministerium für das Jahr 2024 mit durchschnittlich
            1,7 Prozent angesetzt hat.
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-list>
          <ion-item lines="inset">
            <ion-select
              label="Sind Sie 23 Jahre oder älter?"
              labelPlacement="floating"
              interface="popover"
              [(ngModel)]="dSS.olderThan23"
              (ionChange)="update($event)"
            >
              <ion-select-option
                *ngFor="let option of JaNeinList"
                [value]="option.value"
              >
                {{ option.display }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="dSS.olderThan23">
      <ion-col>
        <ion-list>
          <ion-item lines="inset">
            <ion-select
              label="Anzahl Kinder < 25 Jahre"
              labelPlacement="floating"
              interface="popover"
              [(ngModel)]="dSS.anzahlKinder"
              (ionChange)="update($event)"
            >
              <ion-select-option
                *ngFor="let option of anzahlKinderList; let i = index"
                [value]="option"
              >
                {{ option }}
                <span *ngIf="option === 5">+</span>
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ng-container>
  <ng-container *ngIf="dSS.kvValue !== 'gkv'">
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="Beitrag private Kranken- und Pflegeversicherung"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.pkvValue"
            (ionChange)="update($event)"
          >
            <ion-icon
              *ngIf="false"
              name="logo-euro"
              class="eur_logo__position"
            ></ion-icon>
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="AG-Anteil private Kranken- und Pflegeversicherung"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.pvAnteil"
            (ionChange)="update($event)"
          >
            <ion-icon
              *ngIf="false"
              name="logo-euro"
              class="eur_logo__position"
            ></ion-icon>
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
  </ng-container>
  <ion-row *ngIf="!dSS.dienststelle?.hideVBL && dSS.bArt !== 2">
    <ion-col>
      <ion-item lines="inset">
        <ion-input
          label="Arbeitnehmeranteil Zusatzversorgung (bspw. VBL) %"
          labelPlacement="floating"
          type="number"
          [step]="0.01"
          [pattern]="'^[0-9]{1,4}([,.][0-9]{1,4})?$'"
          [(ngModel)]="dSS.dienststelle.VBL"
          [disabled]="dSS.isDienststelleLocked()"
          (ionChange)="update($event)"
        >
        </ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-container>
